import { useEffect } from 'react';
import { Drawer } from '@mweb/zappos-ui/Drawer';

import { STABILITY_ICON_URL, SUPPORT_ICON_URL } from 'constants/product';

interface TechSpecsDrawerProps {
  isMobile: boolean;
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
  triggerRef?: React.RefObject<HTMLButtonElement>;
}

export const TechSpecsDrawer = ({ isMobile, isOpen, setIsOpen, triggerRef }: TechSpecsDrawerProps) => {
  useEffect(() => {
    if (!isOpen && triggerRef?.current) {
      triggerRef.current.focus();
    }
  }, [isOpen, triggerRef]);

  return (
    <Drawer
      contentClassName="z-30 focus:z-30"
      dataTestId="techSpecsDrawer"
      open={isOpen}
      onOpenChange={setIsOpen}
      position={isMobile ? 'bottom' : 'right'}
      title="Support Type"
    >
      <div className="flex flex-col gap-y-6 text-base">
        <div className="flex gap-x-2">
          <img className="h-10 w-10 object-contain" src={STABILITY_ICON_URL} alt="Shoe Stability" />
          <div className="flex flex-col gap-y-1 px-2">
            <h4 className="text-base font-bold">Stability</h4>
            <p className="text-sm">
              Best for runners who overpronate (when your foot rolls inward excessively) or have low or flat arches. These shoes provide extra
              support and motion control to help correct your foot's alignment.
            </p>
          </div>
        </div>
        <hr className="border-dashed" />
        <div className="flex gap-x-2">
          <img className="h-10 w-10 object-contain" src={SUPPORT_ICON_URL} alt="Shoe Support" />
          <div className="flex flex-col gap-y-1 px-2">
            <h4 className="border-moderate text-base font-bold">Neutral</h4>
            <p className="text-sm">
              Best for runners who have a normal arch and your foot strikes naturally without excessive inward or outward rolling.
            </p>
          </div>
        </div>
      </div>
    </Drawer>
  );
};
